import { AttributeKey, TournamentState } from '@ps/poker-games-tile-mappers';
import classNames from 'clsx';
import React from 'react';

import styles from './Attribute.scss';

interface AttributeProps {
  attributeKey: AttributeKey;
  value: string;
  name?: string;
  icon?: React.ReactNode;
  className?: string;
}

const classNameMap = {
  [AttributeKey.ante]: 'ante',
  [AttributeKey.buttonBlind]: 'buttonBlind',
  [AttributeKey.buyIn]: 'buyIn',
  [TournamentState.RUNNING]: 'running',
  [TournamentState.CANCELLED]: 'cancelled',
  [TournamentState.LATE_REGISTRATION]: 'lateReg',
  [TournamentState.ANNOUNCED]: 'announced',
  [TournamentState.COMPLETED]: 'completed'
};

const Attribute: React.FC<AttributeProps> = ({ attributeKey, value, icon, name, className }) => (
  <div
    title={name}
    className={classNames(styles.attribute, styles[classNameMap[attributeKey]], className)}
  >
    {icon && <div className={styles.icon}>{icon}</div>}
    <div className={styles.text}>{value}</div>
  </div>
);

export default Attribute;
